var _defs, _g, _filter;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataSaver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 119,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, "Data Saver") : title ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.97%",
    y1: "2.733%",
    x2: "101.751%",
    y2: "90.46%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#366cf7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003bcc",
    stopOpacity: 0.993,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 0 0-1.02.24l-2.2 2.2a15.074 15.074 0 0 1-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z",
    id: "b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M0 0h50v50H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.67 87.54L45.21 86l7.66-3.42-3.17-7.22a10.44 10.44 0 0 0-8.87-5.57H25.07a10.44 10.44 0 0 0-8.87 5.57L13 82.58 20.66 86l-2.46 1.54-1.36 11.73L33 99l16.08.25-1.41-11.71z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.87 82.58l1.58 5.22a10.07 10.07 0 0 1-3.19 10.6l-7.17 5.6-2.31-6.27 4-3.71a4 4 0 0 0 1-4.62L45.21 86l7.66-3.42zM21.55 116.21l-6.39.86-1.23-1.35.63-2.45 6.14-.88z",
    fill: "#F8B68F",
    filter: "url(#grayscale)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.16 117.07l-8 1s-7.91 1-6.77-3.34c1.1-4.21 8.2-2.34 8.2-2.34l6.61.8a3.35 3.35 0 0 0-.09 3.75l.05.13z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.35 114.73a3.76 3.76 0 0 1 3.39-2.65v6c-1.99-.21-4.01-1-3.39-3.35z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.59 113.62v2.59",
    fill: "#F8B68F",
    filter: "url(#grayscale)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.26 113.62h.66v2.58h-.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96 113.62v2.59",
    fill: "#F8B68F",
    filter: "url(#grayscale)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.63 113.62h.66v2.58h-.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.11 82.58l-1.58 5.22a10.07 10.07 0 0 0 3.19 10.6l7.17 5.61 2.31-6.27-4-3.71a4 4 0 0 1-1-4.62L20.73 86l-7.62-3.42zM45.03 116.69l6.5.38 1.23-1.35-.62-2.45-6.14-.88z",
    fill: "#F8B68F",
    filter: "url(#grayscale)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.53 117.07l8 1s7.92 1 6.78-3.34c-1.11-4.21-8.21-2.34-8.21-2.34l-6.61.8a3.35 3.35 0 0 1 .09 3.75l-.05.13z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.35 114.73a3.77 3.77 0 0 0-3.4-2.65v6c1.99-.21 4.05-1 3.4-3.35z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1 113.63v2.58",
    fill: "#F8B68F",
    filter: "url(#grayscale)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M54.77 113.63h.66v2.58h-.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.74 113.63v2.58",
    fill: "#F8B68F",
    filter: "url(#grayscale)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M56.4 113.63h.66v2.58h-.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBB",
    d: "M20.8 90.22h26.5v15.86H20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBB8CD",
    d: "M20.8 105.43h26.5v1.32H20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 96.7a1.06 1.06 0 1 0 2.12 0 1.06 1.06 0 0 0-2.12 0z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.27 101.85c5.3 9.44-48 15.22-48 15.22l-.9-4.2s42.37-22.65 48.9-11.02z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.42 101.85c-4.5 9.84 48.48 15.74 48.48 15.74l.39-4.73S5.74 90.22.42 101.85z",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.74 69.75c-.49-1.49-1.38-5.89-1.38-5.89l-5.67 1.1v4.82a7.66 7.66 0 0 0 3.46 1.35 5.64 5.64 0 0 0 3.59-1.38z",
    fill: "#F4A086",
    filter: "url(#grayscale)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.75 56l-1.07-6.3L23.77 51l.66 7.26s.85 9 6.65 7.92C37.36 65.06 36 56 35.75 56z",
    fill: "#F8B68F",
    filter: "url(#grayscale)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.29 55.18a4.33 4.33 0 0 1 .47-2.62c1.88-3.08-1-4-2-4.25s-1.45-2-2.93-2.55c-2.25-.83-3.52 1.19-4.75 1.34-1.23.15-2.43-1.15-3.85.2-1.42 1.35-.81 2.61-1.17 3.34-.36.73-1.84-.49-2.91 1.79a2.29 2.29 0 0 0 1.19 3.33 4.84 4.84 0 0 0 4.17.1 19 19 0 0 0 4.37-2.65c.43-.35 3.75-.58 4-.11.94 1.61 1 6.93 1 6.93l1-1.36a3.44 3.44 0 0 0 1.41-3.49z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.72 56.83c-.3.76-.12 1.54.39 1.73.51.19 1.15-.26 1.44-1 .29-.74.12-1.54-.39-1.73-.51-.19-1.16.24-1.44 1z",
    fill: "#F8B68F",
    filter: "url(#grayscale)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.27 34.1s1.68-4 2.33-5.13c2.42-3.65-6-17.62-2.78-20.69 3.22-3.07 28.92-10.9 32.79-6 3.87 4.9 8.38 21.31 3.48 24.63-4.9 3.32-26.23 5.5-28.7 5.17a9.73 9.73 0 0 0-7.12 2.02z",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#d",
    transform: "translate(-13 -13)"
  }))))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "grayscale"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSaver);
export default __webpack_public_path__ + "static/media/data-saver.7663f12d111b62090a99c656855c6c47.svg";
export { ForwardRef as ReactComponent };